import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/dislikeFilled.svg';

export const IconDislikeFilled = createIconComponent(Icon);
